import $ from 'jquery';
import intlTelInput from 'intl-tel-input';
import mediator from '../mediator';
export var telephoneInput = function telephoneInput() {
  var input = document.querySelector('#phone-format');
  var errorMsg = document.querySelector('#error-msg');
  var validMsg = document.querySelector('#valid-msg');
  var errorMap = ['Invalid number', 'Invalid country code', 'Too short', 'Too long', 'Invalid number'];
  var iti = intlTelInput(input, {
    utilsScript: './custom-js/utils.js?1562189064761',
    separateDialCode: false,
    initialCountry: 'GB',
    bootstrap4: true
  });

  var reset = function reset() {
    input.classList.remove('error');
    errorMsg.innerHTML = '';
    errorMsg.classList.add('hide');
    validMsg.classList.add('hide');
  };

  input.addEventListener('blur', function () {
    reset();

    if (input.value.trim()) {
      if (iti.isValidNumber()) {
        // validMsg.classList.remove('hide');
        document.getElementById('phone').value = iti.getNumber();
        console.log("this is the number : ".concat(document.getElementById('phone').value));
        $('#phone-format').closest('.input-holder').eq(0).addClass('input-success');
        $('#phone-format').closest('.input-holder').eq(0).removeClass('input-error');
      } else {
        input.classList.add('error');
        var errorCode = iti.getValidationError();
        errorMsg.innerHTML = errorMap[errorCode];
        errorMsg.classList.remove('hide');
        console.log('uh oh errors exist!!');
        $('#phone-format').closest('.input-holder').eq(0).addClass('input-error');
        $('#phone-format').closest('.input-holder').eq(0).addClass('input-success');
      }
    }
  });
  input.addEventListener('change', reset);
  input.addEventListener('keyup', reset);
};
/* Parsley
  .addValidator('intlTelInput', {
    requirementType : 'integer',
    validateNumber : (value , requirement , options) => {
      return $(options.element).intlTelInput("isValidNumber");
    },
    messages : {
      en : 'Please enter a valid phone number.'
    }
  }); */

export var getDropWidth = function getDropWidth() {
  return $('.iti .telewidth').outerWidth();
};
export var initialDropWidth = function initialDropWidth() {
  var screenSize = window.cigna.screen.breakpoint;

  switch (screenSize) {
    case 'xs':
      $('.iti .iti__country-list').width(getDropWidth());
      break;

    case 'sm':
      $('.iti .iti__country-list').width(getDropWidth());
      break;

    case 'md':
      $('.iti .iti__country-list').width(getDropWidth());
      break;

    case 'lg':
      $('.iti .iti__country-list').width(getDropWidth());
      break;

    case 'xl':
      $('.iti .iti__country-list').width(getDropWidth());
      break;

    default:
      break;
  }

  $('.iti').ready(getDropWidth);
  mediator.on('window:throttledResize', getDropWidth);
};
export default (function () {
  telephoneInput();
  initialDropWidth();
});